import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { LabTestCode } from '../../models/lab-test-code';
import {
    shouldUpdateState,
    storeData
} from '../../utils/converter';
import { getLabTestCodes } from '../../apis/emr-data';

export interface State {
    allIds: string[];
    byId: Dictionary<LabTestCode>;
    loading: Dictionary<boolean>;
}

export const labTestCodes = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: LabTestCode[],
            loadingKey?: string
        ): State => {
            if (shouldUpdateState(data, loadingKey)) {
                const byId = {
                    ...state.byId,
                    ...storeData(data, 'testCode')
                };
                return {
                    ...state,
                    allIds: Object.keys(byId),
                    byId: byId,
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getLabTestCodesAsync(
            _: Undefinable<{}>,
            rootState: RootState
        ) {
            if (selectors.getLabTestCodeIds(rootState.labTestCodes).length === 0) {
                try {
                    const data = await getLabTestCodes();
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    })
});
